import React from 'react';
import { motion } from 'framer-motion';
const Highlight = ({
  children
}: {
  children: React.ReactNode;
}) => <span className="text-orange-500 font-semibold" data-id="element-946">{children}</span>;
const ProblemSection = () => {
  return <section className="w-full bg-white py-16 sm:py-24 md:py-32 lg:py-48" id="product" data-id="element-947">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-948">
        <div className="max-w-4xl mx-auto" data-id="element-949">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-8 sm:mb-12 md:mb-16 tracking-tight leading-tight" data-id="element-950">
            Chat overlays are easy to add.
            <br data-id="element-951" />
            Hard to trust.
          </motion.h2>

          <div className="space-y-8 sm:space-y-10 md:space-y-12 text-lg sm:text-xl md:text-2xl text-gray-600 leading-relaxed font-normal" data-id="element-952">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} data-id="element-953">
              Every product team is adding AI — and most stop at a floating
              chatbot. It can answer questions, but it{' '}
              <Highlight data-id="element-954">can't operate your product</Highlight>:
            </motion.p>

            <motion.ul initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="space-y-3 sm:space-y-4 text-base sm:text-lg md:text-xl lg:text-2xl text-gray-500 pl-4 sm:pl-6" data-id="element-955">
              <li className="flex items-start gap-2 sm:gap-3" data-id="element-956">
                <span className="text-gray-300 mt-1 flex-shrink-0" data-id="element-957">—</span>
                <span data-id="element-958">it can't fill or submit a form</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3" data-id="element-959">
                <span className="text-gray-300 mt-1 flex-shrink-0" data-id="element-960">—</span>
                <span data-id="element-961">it can't navigate to the right screen</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3" data-id="element-962">
                <span className="text-gray-300 mt-1 flex-shrink-0" data-id="element-963">—</span>
                <span data-id="element-964">it can't run a workflow</span>
              </li>
              <li className="flex items-start gap-2 sm:gap-3" data-id="element-965">
                <span className="text-gray-300 mt-1 flex-shrink-0" data-id="element-966">—</span>
                <span data-id="element-967">
                  it can't take actions with permissions, approvals, and audit
                  logs
                </span>
              </li>
            </motion.ul>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-968">
              So users still do all the work. AI becomes a{' '}
              <Highlight data-id="element-969">glorified search bar</Highlight> bolted onto the side
              of your app.
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-900 leading-tight" data-id="element-970">
              The upgrade: AI that <Highlight data-id="element-971">completes work</Highlight> inside
              the UI.
            </motion.p>
          </div>
        </div>
      </div>
    </section>;
};
export default ProblemSection;